import {useMemo} from "react";
import {PageInfo, Pagination} from "../../types/common/Pagination";
import _ from "underscore";
import { useReactiveGetRequest, UseReactiveGetRequest, UseReactiveGetRequestParams } from "./useReactiveGetRequest";

interface UseGetRequestAutoAbortPaginatedParams extends Omit<UseReactiveGetRequestParams, 'shouldAbort'> {
}

export interface UseGetRequestAutoAbortPaginated<T> extends UseReactiveGetRequest<Pagination<T>> {
  responseContent: T | undefined;
  pageInfo: PageInfo | undefined;
}

const useGetRequestAutoAbortPaginated = <T>({ requestUrl, queryParams }: UseGetRequestAutoAbortPaginatedParams): UseGetRequestAutoAbortPaginated<T> => {
  const {
    data,
    setData,
    isLoading,
    setIsLoading,
    error,
    setError,
    meta,
    setMeta,
    doRequest
  } = useReactiveGetRequest<Pagination<T>>({ requestUrl, queryParams, shouldAbort: true });

  const responseContent = useMemo<T | undefined>(() => data?.content, [data]);
  const pageInfo = useMemo<PageInfo | undefined>(() => data ? _.omit(data, 'content') : undefined, [data]);

  return {
    data,
    setData,
    responseContent,
    pageInfo,
    isLoading,
    setIsLoading,
    error,
    setError,
    meta,
    setMeta,
    doRequest
  }
}

export { useGetRequestAutoAbortPaginated };
